import { queryClient } from "./query-client";

/**
 * The travel chain's caches: A&D → Transportation → Accommodation, the
 * Contingent Dashboard that counts all three, and the records (their travel
 * section, the logistics chain strip). One write moves people between their
 * lists — a travel save makes a suggestion and a "needs a room" row, an
 * approval moves a person out of the waiting lists, a trip or a bed takes
 * them off — so every such write refreshes them TOGETHER, not after each
 * module's 30 s staleTime.
 *
 * The roots are literals on purpose: this file is imported by `travel.ts`
 * and `accommodation.ts`, and importing their key objects back would be a
 * cycle. `logistics-cache.test.ts` pins each one to its module's `keys.all`.
 */
export const LOGISTICS_ROOTS = [["travel"], ["transport"], ["accommodation"], ["contingent"], ["accreditations"]] as const;

/** After a write that moves people along the travel chain: every list of the chain refetches. */
export const invalidateLogistics = () => Promise.all(LOGISTICS_ROOTS.map((queryKey) => queryClient.invalidateQueries({ queryKey })));
